module.exports = require("lodash.isempty");